import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

const API_URL = import.meta.env.VITE_API_URL || 'https://api-invoice.ainixit.com/api';

const initialState = {
  plans: [],
  isLoading: false,
  error: null,
};

// Get all plans
export const getPlans = createAsyncThunk(
  'plan/getPlans',
  async (_, { rejectWithValue }) => {
    try {
      const response = await axios.get(`${API_URL}/plans`);
      return response.data.plans;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || 'Failed to fetch plans');
    }
  }
);

const planSlice = createSlice({
  name: 'plan',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getPlans.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getPlans.fulfilled, (state, action) => {
        state.isLoading = false;
        state.plans = action.payload;
      })
      .addCase(getPlans.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      });
  },
});

export default planSlice.reducer;

